import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const useTypewriter = (text, speed = 75, startDelay = 0) => {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    setDisplayed('');
    let index = 0;
    let intervalId;

    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        index += 1;
        setDisplayed(text.slice(0, index));
        if (index >= text.length) {
          clearInterval(intervalId);
        }
      }, speed);
    }, startDelay);

    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, [text, speed, startDelay]);

  return displayed;
};

const About = ({ data }) => {
  const resumePath = `${process.env.PUBLIC_URL}/portfolio/Vedant%20Bhatt.pdf`;
  const typedGreeting = useTypewriter(`Hello! I'm ${data.name}`, 70, 300);

  return (
    <section id="about" className="section-padding bg-[#F5F2E8] dark:bg-gray-900">
      <div className="container-max">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            About Me
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Updated Image Section with your profile photo */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-80 h-80 mx-auto rounded-2xl shadow-2xl overflow-hidden">
              <img
                src={process.env.PUBLIC_URL + '/profile_photo.jpeg'}
                alt={`Portrait of ${data.name}`}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                loading="lazy"
                onError={(e) => {
                  console.error('Error loading profile image');
                  e.target.onerror = null;
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(data.name)}&size=320&background=4F46E5&color=ffffff&bold=true`;
                }}
              />
            </div>
          </motion.div>

          {/* Text Content Section */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
              {typedGreeting}
              {typedGreeting.length < `Hello! I'm ${data.name}`.length && (
                <span className="ml-1 inline-block h-[0.9em] w-[2px] animate-pulse bg-current align-middle" aria-hidden="true"></span>
              )}
            </h3>

            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
              {data.bio}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-2">
                <p className="text-gray-600 dark:text-gray-400">
                  <span className="font-semibold text-gray-900 dark:text-white">Email:</span> {data.email}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href={resumePath}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Download CV
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
